<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Company"></app-page-title>
        <form [formGroup]="companyForm" (ngSubmit)="addCompany()" (keydown.enter)="useEnterKey ? $event.preventDefault() : addCompany()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="code" class="form-label">Code <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="code"
                                            formControlName="txtCode" maxlength="5"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtCode').touched) && companyForm.get('txtCode').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtCode').touched) && companyForm.get('txtCode').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtCode').errors.required">Code is
                                                Required</span>
                                            <span *ngIf="companyForm.get('txtCode').errors.maxlength">Code Max of 5
                                                characters.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="name" class="form-label">Name <span
                                                class="mandatory">*</span></label>
                                        <input type="text" class="form-control form-control-sm" id="name"
                                            formControlName="txtName" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtName').touched) && companyForm.get('txtName').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtName').touched) && companyForm.get('txtName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtName').errors.required">Name is
                                                Required</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="opearationType" class="form-label">Operation Type<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="opearationType" formControlName="ddlOperationType"
                                            [items]="selectOperationTypes" [multiple]="true" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('ddlOperationType').touched) && companyForm.get('ddlOperationType').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || companyForm.get('ddlOperationType').touched) && companyForm.get('ddlOperationType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('ddlOperationType').errors.required">Operation
                                                Type is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="emailid" class="form-label">Email ID </label>
                                        <input type="email" class="form-control form-control-sm" id="emailid"
                                            placeholder="Ex. abc@domain.com" formControlName="txtEmailId" maxlength="50"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtEmailId').touched) && companyForm.get('txtEmailId').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtEmailId').touched) && companyForm.get('txtEmailId').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtEmailId').errors.pattern">Invalid email
                                                format</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="status" class="form-label">Status</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="txtStatus" >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1" *ngIf="showDefault">
                                    <div class="mb-2">
                                        <label for="status" class="form-label">Default</label>
                                        <div class="form-check form-switch form-switch-md">
                                            <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                                formControlName="chkIsDefault" >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="website" class="form-label">Website URL
                                            <i *ngIf="companyForm.get('txtWebsite').value" class="text-secondary ms-2"
                                                style="cursor: pointer;" (click)="redirectToNewWindow()">(click To
                                                redirect)</i></label>
                                        <input type="text" maxlength="150" class="form-control form-control-sm"
                                            id="website" formControlName="txtWebsite"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtWebsite').touched) && companyForm.get('txtWebsite').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtWebsite').touched) && companyForm.get('txtWebsite').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtWebsite').errors.pattern"
                                                title="Please enter a valid URL. The URL should start with 'http://' or 'https://', may include 'www.', 
                                            and must have a valid domain (e.g., example.com). Copy URL from your Website.">Invalid Url Format</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="billingname" class="form-label">Billing Name</label>
                                        <input type="text" class="form-control form-control-sm" id="billingname"
                                            formControlName="txtBillingName" maxlength="30"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtBillingName').touched) && companyForm.get('txtBillingName').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtBillingName').touched) && companyForm.get('txtBillingName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtBillingName').errors.maxlength">Max of of
                                                30 characters.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="billto" class="form-label">Bill To<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="billto" formControlName="ddlBillTo" [items]="billToList"
                                            [appendTo]="'body'" [openOnEnter]="false" 
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('ddlBillTo').touched) && companyForm.get('ddlBillTo').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || companyForm.get('ddlBillTo').touched) && companyForm.get('ddlBillTo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('ddlBillTo').errors.required">Bill To Type is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="allocatedServiceCenters" class="form-label">Service Centers<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="allocatedServiceCenters" formControlName="ddlServiceCenters" placeholder="Select"
                                            [items]="serviceCenterList" [multiple]="true" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'id'"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('ddlServiceCenters').touched) && companyForm.get('ddlServiceCenters').errors}" >

                                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                                    <span class="ng-value-label">{{item.name}}</span>
                                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                                </div>
                                                <div class="ng-value" *ngIf="items.length > 3">
                                                    <span class="ng-value-label">{{items.length - 3}} more...</span>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || companyForm.get('ddlServiceCenters').touched) && companyForm.get('ddlServiceCenters').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('ddlServiceCenters').errors.required">Service Center is Required</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            ADDRESS
                        </div>
                        <div class="card-body">
                            <app-location formGroupName="locationdetails" [location]="locationDetails" 
                                [selectedSCId]="selectedSCId" [isDefaultUserLocationSelected]="true"
                                (getLocation)="getLocation($event)"
                                [formSubmitted]="isFormSubmitted" >
                            </app-location>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 d-flex flex-grow-1 flex-column">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            INFO
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="gstno" class="form-label">GST No. </label>
                                        <input type="text" maxlength="15" class="form-control form-control-sm"
                                            id="gstno" formControlName="txtGstNo"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtGstNo').touched) && companyForm.get('txtGstNo').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtGstNo').touched) && companyForm.get('txtGstNo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtGstNo').errors.pattern">Invalid GST No. Format.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="panno" class="form-label">PAN No.</label>
                                        <input type="text" maxlength="10" class="form-control form-control-sm"
                                            id="panno" formControlName="txtPanNo"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtPanNo').touched) && companyForm.get('txtPanNo').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtPanNo').touched) && companyForm.get('txtPanNo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtPanNo').errors.pattern">Invalid PAN No. Format.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="registrationno" class="form-label">Registration No. </label>
                                        <input type="text" maxlength="20" class="form-control form-control-sm"
                                            id="registrationno" formControlName="txtRegistrationNo"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || companyForm.get('txtRegistrationNo').touched) && companyForm.get('txtRegistrationNo').errors}" >
                                        <div *ngIf="(isFormSubmitted || companyForm.get('txtRegistrationNo').touched) && companyForm.get('txtRegistrationNo').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="companyForm.get('txtRegistrationNo').errors.pattern">Min 5 and
                                                Maximum 20 characters allowed.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-2">
                                        <label for="logo"  class="form-label">Logo ( <small
                                            for="logo"><i class="mdi mdi-information">Note: .png, .jpeg,
                                            .jpg,.svg are only allowed.</i></small> )</label>
                                        <div class="input-group">
                                            <input id="logo" type="file" class="form-control form-control-sm"
                                                accept=".png, .jpeg,.jpg,.svg"
                                                (change)="onChangeFileSelect($event, 'CompanyLogo')" >
                                            <button type="button" class="btn btn-primary btn-sm"
                                                (click)="uploadFile('CompanyLogo')">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>
                                        </div>
                                        <div *ngIf="showLogoProgressBar" class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="logoProgress" [attr.aria-valuenow]="logoProgress" aria-valuemin="0"
                                                aria-valuemax="100">
                                                {{logoProgress}}%
                                            </div>
                                        </div>
                                        <ng-container *ngIf="companyLogoFileURL">
                                            <a target="_blank" [href]="companyLogoFileURL">{{companyLogoFileName}}</a>
                                        </ng-container>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="mb-2">
                                        <label for="signature"  class="form-label">Signature ( <small
                                            for="signature"><i class="mdi mdi-information">Note: .png, .jpeg,
                                            .jpg,.svg are only allowed.</i></small> )</label>
                                        <div class="input-group">
                                            <input id="signature" type="file" class="form-control form-control-sm"
                                                accept=".png, .jpeg,.jpg,.svg"
                                                (change)="onChangeFileSelect($event, 'Signature')" >
                                            <button type="button" class="btn btn-primary btn-sm"
                                                (click)="uploadFile('Signature')">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>
                                        </div>
                                        <div *ngIf="showsignatrueProgressBar" class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="signatrueProgress" [attr.aria-valuenow]="signatrueProgress" aria-valuemin="0"
                                                aria-valuemax="100">
                                                {{signatrueProgress}}%
                                            </div>
                                        </div>
                                        <ng-container *ngIf="signatureFileURL">
                                            <a target="_blank" [href]="signatureFileURL">{{signatureFileName}}</a>
                                        </ng-container>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="row">
                                <!-- <div class="col-sm-12">
                                    <label for="fyfrom" class="form-label">Financial Year </label>
                                    <div class="input-group">
                                      
                                        <ng-select [items]="fyDateList" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                            formControlName="ddlFYDateFrom" >
                                        </ng-select>
                                        <ng-select id="fyfrom" [items]="fyMonthList" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                            formControlName="ddlFYMonthFrom" >
                                        </ng-select>
                                        <span class="input-group-text group-label-sm">To</span>
                                        <ng-select [items]="fyDateList" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                            formControlName="ddlFYDateTo" >
                                        </ng-select>
                                        <ng-select id="fyto" [items]="fyMonthList" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                            formControlName="ddlFYMonthTo" >
                                        </ng-select>
                                    </div>
                                </div> -->

                                <!-- <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="fyfrom" class="form-label">Financial Year From </label>
                                        <div class="input-group d-flex">
                                            <ng-select [items]="fyDateList" [appendTo]="'body'" [openOnEnter]="false"
                                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                                formControlName="ddlFYDateFrom">
                                            </ng-select>
                                            <ng-select id="fyfrom" [items]="fyMonthList" [appendTo]="'body'" [openOnEnter]="false"
                                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                                formControlName="ddlFYMonthFrom">
                                            </ng-select>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="fyto" class="form-label">Financial Year To </label>
                                        <div class="input-group d-flex">
                                            <ng-select [items]="fyDateList" [appendTo]="'body'" [openOnEnter]="false"
                                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                                formControlName="ddlFYDateTo">
                                            </ng-select>
                                            <ng-select id="fyto" [items]="fyMonthList" [appendTo]="'body'" [openOnEnter]="false"
                                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom ng-select-fy"
                                                formControlName="ddlFYMonthTo">
                                            </ng-select>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills bg-light rounded nav">
                            <li [ngbNavItem]="1">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                                    <span class="d-none d-sm-block">Bank Details</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="BankDetails"></ng-template>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                    <span class="d-none d-sm-block">Terms and Conditions</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="TermsContent"></ng-template>
                                </ng-template>
                            </li>
                            <!-- <li [ngbNavItem]="3">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                    <span class="d-none d-sm-block">Financial Year</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="FinancialYearContent"></ng-template>
                                </ng-template>
                            </li> -->
                        </ul>
                        <div [ngbNavOutlet]="justifiednav"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm" (keydown.enter)="addCompany()" *ngIf="permConfig.isAddAllowed" >Add</button>
                        <a routerLink="/setup/companies"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>

            <!-- Tab Content -->
            <ng-template #BankDetails>
                <app-bank-details formGroupName="bankDetails"></app-bank-details>
            </ng-template>
            <ng-template #TermsContent>
                <div class="mt-2">
                    <app-terms-conditions formGroupName="terms"></app-terms-conditions>
                </div>
            </ng-template>
            <!-- <ng-template #FinancialYearContent>
                <div class="mt-2">
                    <app-financial-year [(financialYearList)]="financialYearList" (financialYearEmit)="financialYearfun($event)"></app-financial-year>
                </div>
            </ng-template> -->
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>